import View from './View.js';

class AddRecipeView extends View {
    _parentElement = document.querySelector('.upload');
    _successMessage = 'Recipe was successfully added to our database';
    _errorMessage = 'Ingredient validation failed. Check your info';
    _window = document.querySelector('.add-recipe-window');
    _overlay = document.querySelector('.overlay');
    _btnOpen = document.querySelector('.nav__btn--add-recipe');
    _btnClose = document.querySelector('.btn--close-modal');

    // This is for adding the event listener once with instantiate AddRecipeView
    constructor() {
        // Here we explicitly call parent class 'View'
        super();
        this._addHandlerShowWindow();
        this._addHandlerHideWindow();
    }

    toggleWindow() {
        this._overlay.classList.toggle('hidden');
        this._window.classList.toggle('hidden');
    }

    _addHandlerShowWindow() {
        this._btnOpen.addEventListener('click', this.toggleWindow.bind(this));
    }

    _addHandlerHideWindow() {
        this._btnClose.addEventListener('click', this.toggleWindow.bind(this));
        this._overlay.addEventListener('click', this.toggleWindow.bind(this));
    }

    addHandlerUpload(handler) {
        let auxArr = [];
        let nData = 0;
        const those = this;

        this._parentElement.addEventListener('submit', function(e) {
            e.preventDefault();
            // this = _parentElement (form)
            // Without the spread operator we have a weird object so we convert it to an array
            const dataArr = [...new FormData(this)];
            console.log('dataArr from view: ', dataArr);
            // Takes an array of entries and convert it to an object
            const data = Object.fromEntries(dataArr);

            // Data Validation
            dataArr.filter(
                // entry[0] => key entry[1] => value
                entry => entry[0].startsWith('ingredient') && entry[1] !== ''
            ).forEach(ing => {
                nData++;
                auxArr.push(ing[1]);

                if(nData === 3) {
                    const [quantity, unit, description] = auxArr;
                    auxArr = [];
                    nData = 0;

                    if(!(quantity > 0 && unit !== '' && description !== '')) {
                        console.log('this of view addRecipeView: ', this);
                        those.renderError(this._errorMessage, this);
                    }
                }
            });

   
            console.log('data from view: ', data);

            //handler(data);
        });
    }

    _generateMarkup() {
       
    }
}


export default new AddRecipeView();